import React, { useState } from 'react';
import './style2.scss';
import '../form.scss';
import { Col, Row } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

function ContactForm2() {
  const [inputs, setInputs] = useState({});
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((values) => ({ ...values, [name]: value }));
    
    // Effacer l'erreur du champ lorsqu'on commence à taper
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateForm(inputs);
    if (Object.keys(validationErrors).length === 0) {
      console.log(inputs); // Valid form data
      setErrors({});
      setSuccessMessage('Formulaire soumis avec succès !');
    } else {
      setErrors(validationErrors);
      setSuccessMessage('');
    }
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.nom) {
      errors.nom = 'La raison sociale ou le nom est requis.';
    }
    if (!values.adresse) {
      errors.adresse = "L'adresse est requise.";
    }
    
    // Validation améliorée du numéro de téléphone
    if (!values.telephone) {
      errors.telephone = 'Le numéro de téléphone est requis.';
    } else {
      const phoneValidation = isValidPhone(values.telephone);
      if (!phoneValidation.isValid) {
        errors.telephone = phoneValidation.message;
      }
    }
    
    if (!values.email) {
      errors.email = "L'email est requis.";
    } else if (!isValidEmail(values.email)) {
      errors.email = 'Adresse email invalide.';
    }
    if (!values.responsables) {
      errors.responsables = 'Les noms des responsables sont requis.';
    }
    if (!values.contact) {
      errors.contact = 'Les personnes de contact sont requises.';
    }
    if (!values.employes) {
      errors.employes = 'Le nombre d\'employés est requis.';
    }
    if (!values.secteur) {
      errors.secteur = 'Le secteur d\'activité est requis.';
    }
    if (!values.adhesionType) {
      errors.adhesionType = 'Le type d\'adhésion est requis.';
    }
    if (!values.modePaiement) {
      errors.modePaiement = 'Le mode de paiement est requis.';
    }
    if (!values['Term of Service']) {
      errors['Term of Service'] = 'Vous devez accepter les termes et conditions.';
    }

    return errors;
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Validation améliorée du numéro de téléphone
  const isValidPhone = (phone) => {
    // Nettoyer le numéro : supprimer les espaces, tirets, parenthèses
    const cleanedPhone = phone.replace(/[\s\-\(\)]/g, '');
    
    // Vérifier si le numéro commence par un + (code pays)
    if (cleanedPhone.startsWith('+')) {
      // Numéro international : doit contenir au moins 8 chiffres après le +
      const digitsAfterPlus = cleanedPhone.slice(1).replace(/\D/g, '');
      if (digitsAfterPlus.length < 8) {
        return {
          isValid: false,
          message: "Le numéro international doit contenir au moins 8 chiffres après le code pays"
        };
      }
      
      // Vérifier que tout après le + sont des chiffres
      if (!/^\+\d+$/.test(cleanedPhone)) {
        return {
          isValid: false,
          message: "Le numéro international ne doit contenir que des chiffres après le '+'"
        };
      }
      
      return { isValid: true };
    } else {
      // Numéro local : doit contenir uniquement des chiffres
      if (!/^\d+$/.test(cleanedPhone)) {
        return {
          isValid: false,
          message: "Le numéro de téléphone ne doit contenir que des chiffres"
        };
      }
      
      // Validation pour les numéros tunisiens (8 chiffres)
      if (cleanedPhone.length === 8) {
        // Format tunisien standard : 2X XXX XXX ou 5X XXX XXX ou 9X XXX XXX
        const firstDigit = cleanedPhone[0];
        const secondDigit = cleanedPhone[1];
        
        if (firstDigit === '2' || firstDigit === '5' || firstDigit === '9') {
          if (firstDigit === '2' && !['0','1','2','3','4','5','6','7','8','9'].includes(secondDigit)) {
            return {
              isValid: false,
              message: "Le format du numéro tunisien n'est pas valide"
            };
          }
          if (firstDigit === '5' && !['0','1','2','3','4','5','6','7','8','9'].includes(secondDigit)) {
            return {
              isValid: false,
              message: "Le format du numéro tunisien n'est pas valide"
            };
          }
          if (firstDigit === '9' && !['0','1','2','3','4','5','6','7','8','9'].includes(secondDigit)) {
            return {
              isValid: false,
              message: "Le format du numéro tunisien n'est pas valide"
            };
          }
          
          return { isValid: true };
        } else {
          return {
            isValid: false,
            message: "Le numéro tunisien doit commencer par 2, 5 ou 9"
          };
        }
      } else if (cleanedPhone.length === 13 && cleanedPhone.startsWith('216')) {
        // Format international pour la Tunisie : +216 XX XXX XXX
        const restDigits = cleanedPhone.slice(3);
        if (restDigits.length === 8 && /^\d+$/.test(restDigits)) {
          return { isValid: true };
        }
      }
      
      // Si la longueur n'est pas 8 ou 13, c'est invalide
      return {
        isValid: false,
        message: "Le numéro de téléphone doit contenir 8 chiffres pour un numéro tunisien"
      };
    }
  };

  // Fonction pour formater le numéro de téléphone pendant la saisie
  const formatPhoneNumber = (value) => {
    // Nettoyer la valeur
    const cleaned = value.replace(/\D/g, '');
    
    // Appliquer le format tunisien : XX XXX XXX
    if (cleaned.length <= 2) {
      return cleaned;
    } else if (cleaned.length <= 5) {
      return `${cleaned.slice(0, 2)} ${cleaned.slice(2)}`;
    } else {
      return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)}`;
    }
  };

  const handlePhoneChange = (event) => {
    const value = event.target.value;
    
    // Si la valeur commence par +, on laisse l'utilisateur taper librement
    if (value.startsWith('+')) {
      handleChange(event);
    } else {
      // Sinon, on formate en numéro tunisien
      const formattedValue = formatPhoneNumber(value);
      setInputs((values) => ({ ...values, telephone: formattedValue }));
      
      // Effacer l'erreur du champ téléphone
      if (errors.telephone) {
        setErrors(prev => ({ ...prev, telephone: '' }));
      }
    }
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  return (
    <>
      <Row>
        <Col lg={6}>
          <form className="pgs-form form-control" onSubmit={handleSubmit}>
            
            <div className="row row-gap">
              
              <div className="col-sm-12">
                <div className="input-control">
                  <p>
                  Par la présente, nous vous demandons de bien vouloir remplir 
                  le présent formulaire et payer la cotisation à la Chambre de commerce et 
                  d'industrie Tuniso-Suisse en qualité de membre au titre de l'année 2025

                  </p>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="adhesionType"
                    value="750DT - Membre individuel"
                    onChange={handleChange}
                  />{' '}
                  Membre individuel 750DT
                </div>
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="adhesionType"
                    value="750DT - Jeune entreprise"
                    onChange={handleChange}
                  />{' '}
                  Jeune entreprise (moins de 5 ans) & Startup (label) 750DT
                </div>
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="adhesionType"
                    value="1500DT - Entreprise < 50 salariés"
                    onChange={handleChange}
                  />{' '}
                  Entreprise de moins de 50 salariés 1500DT
                </div>
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="adhesionType"
                    value="2000DT - Entreprise ≥ 50 salariés"
                    onChange={handleChange}
                  />{' '}
                  Entreprise de 50 salariés ou plus 2000DT
                </div>
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="adhesionType"
                    value="3500DT - Multinationales"
                    onChange={handleChange}
                  />{' '}
                  Adhésion «Privilèges» et Multinationales 3500DT
                </div>
                {errors.adhesionType && (
                  <span className="checkbox-error">{errors.adhesionType}</span>
                )}
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Raison Sociale (personne morale) / Nom et prénom (personne physique) :</p>
                  <input
                    type="text"
                    name="nom"
                    value={inputs.nom || ''}
                    onChange={handleChange}
                    placeholder="Raison Sociale / Nom et prénom"
                    className={errors.nom ? 'error-field' : ''}
                  />
                  {errors.nom && <div className="error-message-field">{errors.nom}</div>}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Adresse :</p>
                  <input
                    type="text"
                    name="adresse"
                    value={inputs.adresse || ''}
                    onChange={handleChange}
                    placeholder="Adresse"
                    className={errors.adresse ? 'error-field' : ''}
                  />
                  {errors.adresse && <div className="error-message-field">{errors.adresse}</div>}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Téléphone :</p>
                  <input
                    type="tel"
                    name="telephone"
                    value={inputs.telephone || ''}
                    onChange={handlePhoneChange}
                    placeholder="Ex: 20 123 456 ou +216 20 123 456"
                    className={errors.telephone ? 'error-field' : ''}
                    maxLength="14" // Pour le format XX XXX XXX
                  />
                  {errors.telephone && <div className="error-message-field">{errors.telephone}</div>}
                  <div className="phone-hint">
                    Format accepté : 8 chiffres (ex: 20 123 456) ou format international (ex: +216 20 123 456)
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Col>

        <Col lg={6}>
          <form className="pgs-form form-control" onSubmit={handleSubmit}>
            <div className="row row-gap">
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Email :</p>
                  <input
                    type="email"
                    name="email"
                    value={inputs.email || ''}
                    onChange={handleChange}
                    placeholder="Email"
                    className={errors.email ? 'error-field' : ''}
                  />
                  {errors.email && <div className="error-message-field">{errors.email}</div>}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Noms des responsables :</p>
                  <input
                    type="text"
                    name="responsables"
                    value={inputs.responsables || ''}
                    onChange={handleChange}
                    placeholder="Noms des responsables"
                    className={errors.responsables ? 'error-field' : ''}
                  />
                  {errors.responsables && <div className="error-message-field">{errors.responsables}</div>}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Personnes de contact pour la CCITNCH :</p>
                  <input
                    type="text"
                    name="contact"
                    value={inputs.contact || ''}
                    onChange={handleChange}
                    placeholder="Personnes de contact"
                    className={errors.contact ? 'error-field' : ''}
                  />
                  {errors.contact && <div className="error-message-field">{errors.contact}</div>}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Nombre d'employés :</p>
                  <input
                    type="number"
                    name="employes"
                    value={inputs.employes || ''}
                    onChange={handleChange}
                    placeholder="Nombre d'employés"
                    className={errors.employes ? 'error-field' : ''}
                  />
                  {errors.employes && <div className="error-message-field">{errors.employes}</div>}
                </div>
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <p>Secteur d'activité (Produit services) :</p>
                  <input
                    type="text"
                    name="secteur"
                    value={inputs.secteur || ''}
                    onChange={handleChange}
                    placeholder="Secteur d'activité"
                    className={errors.secteur ? 'error-field' : ''}
                  />
                  {errors.secteur && <div className="error-message-field">{errors.secteur}</div>}
                </div>
              </div>

              <div className="input-control">
                <p>Mode de paiement :</p>
              </div>

              <div className="col-sm-12">
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="modePaiement"
                    value="Chèque"
                    onChange={handleChange}
                  />{' '}
                  Chèque
                </div>
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="modePaiement"
                    value="Virement Bancaire"
                    onChange={handleChange}
                  />{' '}
                  Virement Bancaire
                </div>
                <div className="checkbox-control">
                  <input
                    type="radio"
                    name="modePaiement"
                    value="Espèces"
                    onChange={handleChange}
                  />{' '}
                  Espèces
                </div>
                {errors.modePaiement && (
                  <span className="checkbox-error">{errors.modePaiement}</span>
                )}
              </div>
              <hr/>
              <div className="col-sm-12">
                <div className="checkbox-control">
                  <input
                    type="checkbox"
                    name="Term of Service"
                    checked={inputs['Term of Service'] || false}
                    onChange={handleChange}
                    className={errors['Term of Service'] ? 'error-checkbox' : ''}
                  />{' '}
                  J'accepte de mettre mes données
                </div>
                {errors['Term of Service'] && (
                  <div className="error-message-field">{errors['Term of Service']}</div>
                )}
              </div>
              <div className="col-sm-12">
                <div className="input-control">
                  <button className="btn-primary" type="submit">
                    Soumettre<i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </div>
              {successMessage && (
                <div className="col-sm-12">
                  <div className="success-message">{successMessage}</div>
                </div>
              )}
            </div>
          </form>
        </Col>
      </Row>
      <Row>
        <hr className='mt-4'/>
        <Col>
          <p>
            Ci-dessous les coordonnées bancaires de la <b>CCITNCH</b> (Chambre de commerce et d'industrie tuniso‐suisse).<br />
            <b>RIB n° 04062146002044607643</b><br />
            <b>Attijari Bank</b><br />
            <b>Agence Cité El Khadra</b><br />
            Les chèques doivent être libellés au nom de la <b>« CCITNCH »</b>.<br />
            Des subventions dans le cadre de la promotion du travail de la Chambre sont les bienvenues.
            À la réception du présent formulaire, un reçu d'adhésion vous sera envoyé.
          </p>
        </Col>
      </Row>

      <style jsx>{`
        .error-field {
          border-color: #dc3545 !important;
          border-width: 2px !important;
        }
        
        .error-checkbox {
          outline: 2px solid #dc3545 !important;
        }
        
        .error-message-field {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 4px;
          font-weight: 500;
          display: block;
        }
        
        .checkbox-error {
          color: #dc3545;
          font-size: 0.875rem;
          font-weight: 500;
          display: block;
          margin-top: 4px;
        }
        
        .success-message {
          background: #d4edda;
          color: #155724;
          padding: 12px;
          border-radius: 4px;
          border: 1px solid #c3e6cb;
          text-align: center;
          margin-top: 15px;
        }
        
        .phone-hint {
          color: #6c757d;
          font-size: 0.75rem;
          margin-top: 4px;
          font-style: italic;
        }
      `}</style>
    </>
  );
}

export default ContactForm2;